module.exports = __webpack_public_path__ + "img/任县密封件.6a9a7c69.jpg";